Vue.component("push-message-default", {
    props: ["cfg"],
    template: `
        <div class="push-messages__message push-message" :class="[cfg.content.class]" >


            <div class="push-message__btn-close" @click="onCloseClicked"></div>

            <div class="push-message__inner-wrapper">
                <h1 v-if="cfg.content.header" class="push-message__heading">{{cfg.content.header}}</h1>
                <p v-if="cfg.content.body" class="push-message__text">{{cfg.content.body}}</p>


                <div class="push-message__button-container">
                    <div @click="onCloseClicked" class="push-message__button push-message__button--dismiss">Nej tak</div>
                    <div v-if="cfg.content.link" @click="onLinkedClick" class="push-message__button push-message__button--action" >
                        {{cfg.content.link.text}}
                    </div>
                </div>
            </div>

        </div>
    `,
    methods: {
        onLinkedClick () {
            this.$emit("link-clicked")
        },
        onCloseClicked () {
            this.$emit("close")
        }
    }
});